/**
 * Generates fallback text for a link when the title is missing
 * @param link The link object
 * @returns A fallback text string
 */
export function getFallbackLinkText(link) {
    if (link.title) {
        return link.title;
    }
    try {
        // Try to extract domain from URL for a more user-friendly fallback
        const url = new URL(link.url);
        return url.hostname;
    }
    catch (e) {
        // If URL parsing fails, use a generic fallback
        return "Visit Link";
    }
}
